;(function () {
  'use strict'

  angular
    .module('contrast.servers')
    .factory('ServerPropertiesService', ServerPropertiesService)

  function ServerPropertiesService($translate, ServerService) {
    'ngInject'

    var service = {
      buildDotNetServer: buildDotNetServer,
      buildFormattedProperties: buildFormattedProperties
    }

    return service

    function buildDotNetServer(serverId) {
      return ServerService.getServerProperties(serverId).then(function (data) {
        var serverProperties = data.serverProperties
        if (data && data.serverProperties && data.serverProperties.custom) {
          serverProperties.custom = _buildDotNetCustom(
            data.serverProperties.custom
          )
        }
        return serverProperties
      })
    }

    function _buildDotNetCustom(jsonString) {
      var custom = {}
      if (jsonString) {
        custom = JSON.parse(jsonString)
        if (custom && custom.appPools) {
          custom.appPools = JSON.parse(custom.appPools)
        }
      }
      return custom
    }

    function buildFormattedProperties(server) {
      server.formattedProperties = {
        clrVersion: _getCLRVersion(server.serverProperties),
        processor: _getProcessor(server.serverProperties),
        memory: _getHostMemory(server.serverProperties)
      }
    }

    function _getCLRVersion(serverProperties) {
      return serverProperties ? serverProperties.language_version : null
    }

    function _getProcessor(serverProperties) {
      if (serverProperties && serverProperties.custom) {
        if (serverProperties.custom.processor) {
          if (serverProperties.custom['host.numcores']) {
            return (
              serverProperties.custom.processor +
              ' - (' +
              $translate.instant(
                'plural_serverNotes_nCores',
                { count: serverProperties.custom['host.numcores'] },
                'messageformat'
              ) +
              ')'
            )
          } else {
            return serverProperties.custom.processor
          }
        }
      }
      return null
    }

    function _getHostMemory(serverProperties) {
      if (serverProperties && serverProperties.custom) {
        var kb = serverProperties.custom['host.memorykb']
        var mb = kb / 1000
        return mb
      }
      return null
    }
  }
})()
